import { ButtonProps } from '../Button';
import AffiliateButton from './AffiliateButton';
import GoFanImage from 'images/icons/go-fan.png';

export default function GoFanButton({ children, ...props }: ButtonProps) {
  return (
    <AffiliateButton {...props} image={GoFanImage}>
      {children || 'Buy Tickets With'}
    </AffiliateButton>
  );
}
